import React, { useState, useEffect } from "react";
import { Filter } from "lucide-react";
import {
  SiWhatsapp, SiInstagram, SiFacebook, SiTwitter, SiLinkedin, SiYoutube,
  SiSlack, SiZoom, SiSkype, SiMicrosoftteams, SiGooglemeet, SiGithub,
  SiReddit, SiPinterest, SiSnapchat, SiTiktok, SiAmazon, SiNetflix,
  SiSpotify, SiHulu, SiCrunchyroll, SiTwitch, SiDiscord, SiTelegram,
  SiSignal, SiWechat, SiLine, SiViber, SiMessenger, SiNotion, SiTrello,
  SiAsana, SiJira, SiConfluence, SiClickup, SiAirtable, SiTodoist,
  SiEvernote, SiDropbox, SiGoogledrive, SiIcloud, SiBox,
} from "react-icons/si";
import {
  SiMicrosoftword, SiMicrosoftexcel, SiMicrosoftpowerpoint,
  SiMicrosoftoutlook, SiMicrosoftonenote, SiMicrosoftsharepoint,
  SiMicrosoftonedrive,
} from "react-icons/si";
import {
  MdSettings, MdCameraAlt, MdPhotoLibrary, MdPhoneAndroid, MdFolder,
  MdSecurity, MdHome, MdNotes, MdMessage, MdMap, MdApps, MdPlayArrow,
} from "react-icons/md";
import Arthatrack from "../../Assets/arthaTrack-Logo-01.png";
import { Dialog, DialogTitle, DialogContent } from "@mui/material";
import Select from "react-select";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import {
  FetchTimesheetApi,
  FetchTimesheetHoursClickApi,
  FetchAppUsageApi,
  SaveEditedEntriesApi, // Import the API function
} from "../../actioncreators/actioncreators";
import "react-datepicker/dist/react-datepicker.css";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import {
  imagedata,
  timeentries,
  workedhours,
  approvaldata,
} from "../../actions/loanAction";
import TimeEntries from "./TimeEntries";
import "./dashboard.css";
import ArthaContinueButton from "../../fields/ArthaContinueButton";
import ArthaCancelButton from "../../fields/ArthaCancelButton";
import ApprovalTimeEntries from "./ApprovalTimeEntries";
import { toast } from "react-toastify";

const AppMonitering = () => {
  const navigate = useNavigate();
  const [activeMenu, setActiveMenu] = useState("Dashboard");
  const [timesheetData, setTimesheetData] = useState([]);
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [response, setresponse] = useState(false);
  const [showContent, setShowContent] = useState(false);
  const [selectedTab1, setSelectedTab1] = useState("Workspace");
  const [approvalResponse, setApprovalResponse] = useState([]);
  const [showApprovalContent, setShowApprovalContent] = useState("Workspace");
  const [allowedTimeChecked, setAllowedTimeChecked] = useState({});
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [selectedAuthorisation, setSelectedAuthorisation] = useState([]);
  const [isEditMode, setIsEditMode] = useState(false);
  const [tableOpacity, setTableOpacity] = useState(0.8); // Add state for table opacity
  const [currentPage, setCurrentPage] = useState(1);
  const entriesPerPage = 20;
  const [totalPages, setTotalPages] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);

  const handleSave = async () => {
    // Filter out only edited entries, but skip arthaTRACK if it's the only one
    let editedEntries = approvalResponse?.filter((app) => app.isEdited);

    // If only arthaTRACK is edited, skip saving
    if (
      editedEntries.length === 1 &&
      editedEntries[0].app_name === "arthaTRACK"
    ) {
      toast.info("No changes to save.");
      setIsEditMode(false);
      return;
    }

    // Remove arthaTRACK from payload if present
    editedEntries = editedEntries.filter((app) => app.app_name !== "arthaTRACK");

    // If nothing left to save, just exit edit mode
    if (editedEntries.length === 0) {
      setIsEditMode(false);
      return;
    }

    const applicationData = editedEntries?.map((app) => {
      const allowedTime =
        typeof app.allowed_time_minutes === "number"
          ? convertMinutesToHoursAndMinutes(app.allowed_time_minutes)
          : { hours: 0, mins: 0 };
      const totalMinutes = allowedTime.hours * 60 + allowedTime.mins;

      return {
        old_data: {
          allowed_time_minutes: app.old_allowed_time_minutes || null,
          app_category: app.app_category,
          app_name: app.app_name,
          organization_applications_id: app.organization_applications_id,
          is_authorised: app.old_is_authorised || null,
        },
        new_data: {
          allowed_time_minutes: totalMinutes,
          app_category: app.app_category,
          app_name: app.app_name,
          organization_applications_id: app.organization_applications_id,
          is_authorised: app.is_authorised === "Authorised",
        },
      };
    });

    const payload = {
      applicationData,
    };

    try {
      const response = await SaveEditedEntriesApi(payload);
      if (response.businessStatusCode === 2) {
        toast.success("Entries saved successfully!");
        setIsEditMode(false);
      }
    } catch (error) {
      console.error("Error saving entries:", error);
      toast.error("Failed to save entries.");
    }
  };

  const handleToggleEditMode = () => {
    if (isEditMode) {
      handleSave(); // Call handleSave when exiting edit mode
    }
    setIsEditMode((prevMode) => !prevMode);
    setTableOpacity((prevMode) => (prevMode === 1 ? 0.7 : 1)); // Toggle table opacity
  };

  const tabs = ["Workspace"];
  const [selectedDate, setSelectedDate] = useState(new Date());
  const getCurrentWeekSunday = (date) => {
    const monday = new Date(date);
    const sunday = new Date(monday);
    sunday.setDate(monday.getDate() + 6); // Sunday is 6 days after Monday
    return sunday.toISOString().split("T")[0]; // Return in YYYY-MM-DD format
  };
  const getCurrentWeekMonday = (date) => {
    const currentDate = new Date(date); // Convert input to Date object
    const dayOfWeek = currentDate.getDay(); // Get the current day of the week (0 = Sunday, 6 = Saturday)
    const diff = currentDate.getDate() - dayOfWeek + (dayOfWeek === 0 ? -6 : 1); // Calculate difference to Monday
    const monday = new Date(currentDate.setDate(diff)); // Set the date to the Monday of the week
    return monday.toISOString().split("T")[0]; // Return the date in YYYY-MM-DD format
  };

  const [mondayDate, setMondayDate] = useState(
    getCurrentWeekMonday(new Date())
  );
  useEffect(() => {
    const newMondayDate = getCurrentWeekMonday(selectedDate);
    const newSundayDate = getCurrentWeekSunday(selectedDate);
    setMondayDate(newMondayDate);
    setSundayDate(newSundayDate);
  }, [selectedDate]);

  const fetchAppsData = async (pageNumber = 1, categories = [], authorisations = []) => {
    setIsLoading(true);
    setError(null);

    try {
      const payload = {
        entity_type: "organization_applications",
        pagenumber: pageNumber,
      };

      // Add filter conditions if filters are selected
      const parameter = [];
      
      if (categories.length > 0) {
        categories.forEach(category => {
          parameter.push({
            columnName: "app_category",
            condition: "=",
            value: category.value.toLowerCase()
          });
        });
      }

      if (authorisations.length > 0) {
        authorisations.forEach(auth => {
          // Convert string values to boolean/null for API
          let authValue;
          if (auth.value === "Authorised") {
            authValue = true;
          } else if (auth.value === "Unauthorised") {
            authValue = false;
          } else if (auth.value === "Not Decided") {
            authValue = "";
          }
          
          parameter.push({
            columnName: "is_authorised",
            condition: "=",
            value: authValue
          });
        });
      }

      if (parameter.length > 0) {
        payload.parameter = parameter;
      }

      const response = await FetchAppUsageApi(payload);
      console.log("approvalresponse", response);
      setApprovalResponse(response?.viewListData || []);
      setTotalPages(response?.totalPages || 0);
      setTotalRecords(response?.totalRecords || 0);
    } catch (err) {
      setError(err.message);
    } finally {
      setIsLoading(false);
    }
  };

  const [sundayDate, setSundayDate] = useState(
    getCurrentWeekSunday(new Date())
  );

  useEffect(() => {
    fetchAppsData();
  }, []);

  const handlePreviousWeek = () => {
    const prevMonday = new Date(mondayDate);
    prevMonday.setDate(prevMonday.getDate() - 7); // Move to the previous Monday
    setMondayDate(prevMonday.toISOString().split("T")[0]); // Update Monday

    // Update Sunday date
    const prevSunday = new Date(prevMonday);
    prevSunday.setDate(prevSunday.getDate() + 6); // Move to the next Sunday
    setSundayDate(prevSunday.toISOString().split("T")[0]); // Update Sunday
  };

  const getCurrentWeekDates = () => {
    const today = new Date();
    const currentDay = today.getDay(); // Get the current day (0 is Sunday, 1 is Monday, etc.)

    // Get the difference to the most recent Monday
    const diffToMonday = currentDay === 0 ? -6 : 1 - currentDay; // If today is Sunday (0), go back 6 days
    const currentMonday = new Date(
      today.setDate(today.getDate() + diffToMonday)
    ); // Set the date to this week's Monday
    const currentSunday = new Date(currentMonday); // Copy Monday date to calculate Sunday
    currentSunday.setDate(currentMonday.getDate() + 6); // Set Sunday to be 6 days after Monday

    setMondayDate(currentMonday.toISOString().split("T")[0]);
    setSundayDate(currentSunday.toISOString().split("T")[0]);
  };

  // Function to handle the next week button click
  const handleNextWeek = () => {
    const nextMonday = new Date(mondayDate);
    nextMonday.setDate(nextMonday.getDate() + 7); // Move to the next Monday
    setMondayDate(nextMonday.toISOString().split("T")[0]); // Update Monday

    // Update Sunday date
    const nextSunday = new Date(nextMonday);
    nextSunday.setDate(nextSunday.getDate() + 6); // Move to the next Sunday
    setSundayDate(nextSunday.toISOString().split("T")[0]); // Update Sunday
  };

  // Disable "Next Week" button if it's the current week
  const isNextWeekDisabled = () => {
    const today = new Date();
    const todayMonday = new Date(mondayDate); // Get the current displayed Monday
    todayMonday.setDate(todayMonday.getDate() + 7); // Move it to next Monday

    return today < todayMonday; // Disable "Next Week" if today is before the next Monday
  };

  useEffect(() => {
    getCurrentWeekDates(); // Initialize with the current week's dates
  }, []); // Empty dependency array ensures this runs once when the component mounts

  const parseTime = (timeString) => {
    const [hours, minutes] = timeString.match(/\d+/g) || [0, 0];
    return {
      hours: parseInt(hours, 10),
      minutes: parseInt(minutes, 10),
    };
  };

  const handleApprovalRowClick = async (employee) => {
    console.log("employee", employee);
    const payload = {
      date: mondayDate, // Use the current week's Monday date
      userId: employee.user_id, // The clicked user's ID
    };

    try {
      const response = await FetchTimesheetHoursClickApi(
        payload.date,
        payload.userId
      );
      setresponse(response.data);
      dispatch(approvaldata(response.data));
      const body = {
        timeentries: employee.daily,
        weekStart: mondayDate,
        weekEnd: sundayDate,
        selectedDate: mondayDate,
        selectedIndex: approvalResponse?.indexOf(employee),
        totalWorkedHours: employee.totalWorkedHours,
        totalBreakHours: employee.totalBreakHours,
      };
      console.log("body", body);
      // Dispatch the worked hours for this specific record
      dispatch(timeentries(body));

      dispatch(
        imagedata({
          fullName: employee.full_name,
        })
      );
      navigate("/home/approvaltimeentries");
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const [isApproveDialogOpen, setIsApproveDialogOpen] = useState(false);
  const [selectedEmployee, setSelectedEmployee] = useState(null);

  const handleApproveConfirm = () => {
    // Add your approve logic here
    setIsApproveDialogOpen(false);
  };

  const getAppIcon = (appName, appIconBase64) => {
    const iconSize = 26;

    // If device-provided icon (base64) is available, use it
    if (appIconBase64) {
      return <img src={`data:image/png;base64,${appIconBase64}`} alt={appName} style={{ width: iconSize, height: iconSize, borderRadius: 4 }} />;
    }

    // Special case for arthaTRACK
    if (appName === 'arthaTRACK' || appName.toLowerCase() === 'arthatrack') {
      return <img src={Arthatrack} alt="arthaTRACK" style={{ width: iconSize, height: iconSize }} />;
    }

    // Brand icons using react-icons/si (Simple Icons) with official brand colors
    const brandIcons = {
      whatsapp:        { icon: SiWhatsapp,            color: "#25D366" },
      instagram:       { icon: SiInstagram,           color: "#E4405F" },
      facebook:        { icon: SiFacebook,            color: "#1877F2" },
      twitter:         { icon: SiTwitter,             color: "#1DA1F2" },
      linkedin:        { icon: SiLinkedin,            color: "#0A66C2" },
      youtube:         { icon: SiYoutube,             color: "#FF0000" },
      slack:           { icon: SiSlack,               color: "#4A154B" },
      zoom:            { icon: SiZoom,                color: "#2D8CFF" },
      skype:           { icon: SiSkype,               color: "#00AFF0" },
      microsoft_teams: { icon: SiMicrosoftteams,      color: "#6264A7" },
      teams:           { icon: SiMicrosoftteams,      color: "#6264A7" },
      google_meet:     { icon: SiGooglemeet,          color: "#00897B" },
      github:          { icon: SiGithub,              color: "#181717" },
      reddit:          { icon: SiReddit,              color: "#FF4500" },
      pinterest:       { icon: SiPinterest,           color: "#BD081C" },
      snapchat:        { icon: SiSnapchat,            color: "#FFFC00" },
      tiktok:          { icon: SiTiktok,              color: "#000000" },
      amazon:          { icon: SiAmazon,              color: "#FF9900" },
      netflix:         { icon: SiNetflix,              color: "#E50914" },
      spotify:         { icon: SiSpotify,             color: "#1DB954" },
      hulu:            { icon: SiHulu,                color: "#1CE783" },
      crunchyroll:     { icon: SiCrunchyroll,         color: "#F47521" },
      twitch:          { icon: SiTwitch,              color: "#9146FF" },
      discord:         { icon: SiDiscord,             color: "#5865F2" },
      telegram:        { icon: SiTelegram,            color: "#26A5E4" },
      signal:          { icon: SiSignal,              color: "#3A76F0" },
      wechat:          { icon: SiWechat,              color: "#07C160" },
      line:            { icon: SiLine,                color: "#00C300" },
      viber:           { icon: SiViber,               color: "#7360F2" },
      messenger:       { icon: SiMessenger,           color: "#00B2FF" },
      notion:          { icon: SiNotion,              color: "#000000" },
      trello:          { icon: SiTrello,              color: "#0052CC" },
      asana:           { icon: SiAsana,               color: "#F06A6A" },
      jira:            { icon: SiJira,                color: "#0052CC" },
      confluence:      { icon: SiConfluence,          color: "#172B4D" },
      clickup:         { icon: SiClickup,             color: "#7B68EE" },
      airtable:        { icon: SiAirtable,            color: "#18BFFF" },
      todoist:         { icon: SiTodoist,             color: "#E44332" },
      evernote:        { icon: SiEvernote,            color: "#00A82D" },
      dropbox:         { icon: SiDropbox,             color: "#0061FF" },
      google_drive:    { icon: SiGoogledrive,         color: "#4285F4" },
      onedrive:        { icon: SiMicrosoftonedrive,   color: "#0078D4" },
      box:             { icon: SiBox,                 color: "#0061D5" },
      icloud:          { icon: SiIcloud,              color: "#3693F5" },
      word:            { icon: SiMicrosoftword,       color: "#2B579A" },
      excel:           { icon: SiMicrosoftexcel,      color: "#217346" },
      powerpoint:      { icon: SiMicrosoftpowerpoint, color: "#B7472A" },
      outlook:         { icon: SiMicrosoftoutlook,    color: "#0078D4" },
      onenote:         { icon: SiMicrosoftonenote,    color: "#7719AA" },
      sharepoint:      { icon: SiMicrosoftsharepoint, color: "#0078D4" },
    };

    // System/device icons using react-icons/md (Material Design)
    const systemIcons = {
      settings:              { icon: MdSettings,      color: "#607D8B" },
      camera:                { icon: MdCameraAlt,     color: "#455A64" },
      photos:                { icon: MdPhotoLibrary,  color: "#4285F4" },
      gallery:               { icon: MdPhotoLibrary,  color: "#4285F4" },
      maps:                  { icon: MdMap,           color: "#34A853" },
      notes:                 { icon: MdNotes,         color: "#FBBC04" },
      security:              { icon: MdSecurity,      color: "#4285F4" },
      messages:              { icon: MdMessage,        color: "#1A73E8" },
      'android system':      { icon: MdPhoneAndroid,  color: "#3DDC84" },
      'my files':            { icon: MdFolder,        color: "#FF9800" },
      'google play services':{ icon: MdPlayArrow,     color: "#34A853" },
      'security centre':     { icon: MdSecurity,      color: "#4285F4" },
      'moto app launcher':   { icon: MdHome,          color: "#607D8B" },
      'system launcher':     { icon: MdHome,          color: "#607D8B" },
      'one ui home':         { icon: MdHome,          color: "#1428A0" },
    };

    // Normalize the app name for lookup
    const normalized = appName.toLowerCase().replace(/_/g, ' ');
    const lookup = brandIcons[normalized] || brandIcons[appName.toLowerCase()] || systemIcons[normalized];

    if (lookup) {
      const IconComponent = lookup.icon;
      return <IconComponent size={iconSize} color={lookup.color} />;
    }

    // Default fallback icon
    return <MdApps size={iconSize} color="#9E9E9E" />;
  };

  const handleAllowedTimeChange = (appId) => {
    setAllowedTimeChecked((prevState) => ({
      ...prevState,
      [appId]: !prevState[appId],
    }));
  };

  // Function to convert minutes to hours and minutes
  const convertMinutesToHoursAndMinutes = (minutes) => {
    const hours = Math.floor(minutes / 60);
    const mins = minutes % 60;
    return { hours, mins };
  };

  // Function to handle time input change
  const handleTimeInputChange = (appId, value) => {
    const [hours, minutes] = value.split(":").map(Number);
    const totalMinutes = hours * 60 + minutes;

    setApprovalResponse((prevState) =>
      prevState.map((app) =>
        app.organization_applications_id === appId
          ? { ...app, allowed_time_minutes: totalMinutes, isEdited: true }
          : app
      )
    );
  };

  const handleAuthorisationChange = (appId, value) => {
    setApprovalResponse((prevState) =>
      prevState.map((app) =>
        app.organization_applications_id === appId
          ? { ...app, is_authorised: value, isEdited: true }
          : app
      )
    );
  };

  const categoryOptions = [
    { value: "Social", label: "Social" },
    { value: "Productivity", label: "Productivity" },
    { value: "Entertainment", label: "Entertainment" },
    // Add more categories as needed
  ];

  const authorisationOptions = [
    { value: "Authorised", label: "Authorised" },
    { value: "Unauthorised", label: "Unauthorised" },
  ];

  const handleCategoryChange = (selectedOptions) => {
    setSelectedCategories(selectedOptions);
    setCurrentPage(1); // Reset to page 1 when filter changes
    fetchAppsData(1, selectedOptions, selectedAuthorisation);
  };

  const handleAuthorisationChangeDropdown = (selectedOptions) => {
    setSelectedAuthorisation(selectedOptions);
    setCurrentPage(1); // Reset to page 1 when filter changes
    fetchAppsData(1, selectedCategories, selectedOptions);
  };

  // Removed client-side filtering - now handled by API

  const handlePageChange = (event, pageNumber) => {
    setCurrentPage(pageNumber);
    fetchAppsData(pageNumber, selectedCategories, selectedAuthorisation);
  };

  // Removed client-side pagination - now handled by API

  return (
    <div className="container-fluid p-0 m-0">
      <div
        className="row card rounded"
        style={{ backgroundColor: "#EFF0F4", height: "86vh" }}
      >
        {/* Main Content */}

        <main className="col-12 col-md-12  border text-black-50 shadow">
          <>
            <div className="flex justify-between items-center mt-1">
              <div className="space-x-4 border-bottom text-black-50 w-full flex">
                {tabs.map((tab) => (
                  <button
                    key={tab}
                    // onClick={() => handleTabClick(tab)} // Use handleTabClick here
                    style={{
                      transition: "background-color 0.3s, color 0.3s",
                      borderBottom:
                        selectedTab1 === tab ? "2px solid #fd5f07" : "none", // Apply border only to selected tab
                      marginLeft: "5px",
                      borderRadius: "0px",
                      color: selectedTab1 === tab ? "#fd5f07" : "#000000", // Color based on selected tab
                    }}
                  >
                    {tab}
                  </button>
                ))}
              </div>
            </div>

            {selectedTab1 === "Workspace" && (
              <>
                {/* Filter Section */}
                <div className="col-12 col-md-12 flex justify-between items-center text-black-50 my-3 shadow rounded ps-2 bg-white ">
                  <div className="flex items-center ms-3 my-3  ">
                    <Filter size={16} className="mr-2 " />
                    <Select
                      isMulti
                      options={categoryOptions}
                      value={selectedCategories}
                      onChange={handleCategoryChange}
                      placeholder="Filter by Categories"
                      className="mr-2 text-sm"
                    />
                    <Select
                      isMulti
                      options={authorisationOptions}
                      value={selectedAuthorisation}
                      onChange={handleAuthorisationChangeDropdown}
                      placeholder="Filter by Authorisation"
                      className="text-sm"
                    />
                  </div>
                  <ArthaContinueButton
                    onClick={handleToggleEditMode}
                    className=""
                  >
                    {isEditMode ? "Save" : "Edit"}
                  </ArthaContinueButton>
                </div>

                {/* Timesheet Table */}
                {isLoading ? (
                  <div className="text-center">Loading...</div>
                ) : error ? (
                  <div className="text-center text-red-500">{error}</div>
                ) : !approvalResponse || approvalResponse.length === 0 ? (
                  <div className="d-flex justify-content-center align-items-center" style={{ height: '64vh' }}>
                    <p className="text-muted fw-bold text-center">No Application Data Found</p>
                  </div>
                ) : (
                  <div
                    className="row p-0 rounded-lg shadow m-0"
                    style={{
                      backgroundColor: "#ffffff",
                      opacity: tableOpacity,
                      display: 'flex',
                      flexDirection: 'column',
                      height: '64vh',
                    }}
                  >
                    <div style={{
                      flex: '1 1 auto',
                      overflowY: 'auto',
                      msOverflowStyle: "none",
                      scrollbarWidth: "none",
                    }}>
                      <table
                        className="w-full"
                        style={{ backgroundColor: "#f6f8fb" }}
                      >
                        <thead style={{ position: 'sticky', top: 0, backgroundColor: '#f6f8fb', zIndex: 1 }}>
                          <tr className="text-sm text-black-1000">
                            <th className="col-12 col-md-3 px-4 py-2 text-left">
                              Apps
                            </th>
                            {/* <th className="px-4 py-2 text-left">Email</th> */}
                            <th className="col-12 col-md-3 px-4 py-2 text-left">
                              Categories
                            </th>
                            <th className="col-12 col-md-3 px-4 py-2 text-left">
                              Allowed Time ( per day )
                            </th>
                            <th className="col-12 col-md-3 px-4 py-2 text-left">
                              Authorised/Unauthorised
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {approvalResponse &&
                            approvalResponse.map((app) => {
                              const { hours, mins } =
                                convertMinutesToHoursAndMinutes(
                                  app.allowed_time_minutes || 0
                                );
                              const timeValue = `${String(hours).padStart(
                                2,
                                "0"
                              )}:${String(mins).padStart(2, "0")}`;

                              return (
                                <tr
                                  key={app.organization_applications_id}
                                  className="border-t"
                                >
                                  <td className="col-12 col-md-3  py-2 flex items-center space-x-2 mt-2">
                                    {getAppIcon(app.app_name, app.app_icon)}
                                    <span className="text-sm text-black">
                                      {app.app_name}
                                    </span>
                                  </td>
                                  <td className="col-12 col-md-3 px-4 py-2 text-left text-sm text-black">
                                    {app.app_category}
                                  </td>
                                  <td
                                    className="col-12 col-md-3 px-4 py-2 text-left text-sm text-black"
                                    style={{ fontSize: "12px" }}
                                  >
                                    <input
                                      type="time"
                                      value={timeValue} // Set default value to "00:00"
                                      onChange={(e) =>
                                        handleTimeInputChange(
                                          app.organization_applications_id,
                                          e.target.value
                                        )
                                      }
                                      className="text-sm col-12 col-md-8 w-50 "
                                      style={{ fontSize: "12px" }}
                                      disabled={!isEditMode}
                                    />
                                  </td>
                                  <td className="col-12 col-md-3 px-4 py-2 text-left text-sm text-black">
                                    <select
                                      value={
                                        app.app_name === "arthaTRACK"
                                          ? "Authorised"
                                          : app.is_authorised || "Select Option"
                                      }
                                      onChange={(e) =>
                                        handleAuthorisationChange(
                                          app.organization_applications_id,
                                          e.target.value
                                        )
                                      }
                                      className="text-sm w-75 h-full items-top"
                                      disabled={
                                        !isEditMode ||
                                        app.app_name === "arthaTRACK"
                                      }
                                    >
                                      <option value="Select Option">
                                        Select Option
                                      </option>
                                      <option
                                        value="Authorised"
                                        // If arthaTRACK, make this option selected and disabled
                                        disabled={app.app_name === "arthaTRACK"}
                                      >
                                        Authorised
                                      </option>
                                      <option value="Unauthorised">
                                        Unauthorised
                                      </option>
                                      {/* <option value="Not Decided">
                                          Not Decided
                                        </option> */}
                                    </select>
                                  </td>
                                </tr>
                              );
                            })}
                        </tbody>
                      </table>
                    </div>
                    <div style={{
                      flexShrink: 0,
                      borderTop: '1px solid #e5e7eb',
                      backgroundColor: '#ffffff',
                      padding: '10px 0'
                    }}>
                      <Stack
                        spacing={2}
                        className="pagination"
                        style={{
                          display: "flex",
                          justifyContent: "center",
                        }}
                      >
                        <Pagination
                          count={totalPages}
                          page={currentPage}
                          onChange={handlePageChange}
                          variant="outlined"
                          shape="rounded"
                          className="mx-auto"
                        />
                      </Stack>
                    </div>
                  </div>
                )}
              </>
            )}
          </>

          {activeMenu === "Timesheets" &&
            showContent === true &&
            showApprovalContent !== true && (
              <>
                <TimeEntries onBack={() => setShowContent(false)} />
              </>
            )}
          {activeMenu === "Timesheets" &&
            showApprovalContent === true &&
            showContent !== true && (
              <>
                <ApprovalTimeEntries
                  onBack={() => setShowApprovalContent(false)}
                />
              </>
            )}
        </main>

        <Dialog
          open={isApproveDialogOpen}
          onClose={() => setIsApproveDialogOpen(false)}
          className="text-left"
        >
          <DialogTitle>
            Approve timesheets
            <button
              className="absolute top-2 right-2 text-gray-1000 hover:text-gray-700"
              onClick={() => setIsApproveDialogOpen(false)}
            >
              &times;
            </button>
          </DialogTitle>
          <div className="text-center py-2 mb-2">
            <ArthaCancelButton onClick={() => setIsApproveDialogOpen(false)}>
              Cancel
            </ArthaCancelButton>
            <ArthaContinueButton onClick={handleApproveConfirm}>
              Approve
            </ArthaContinueButton>
          </div>
        </Dialog>
      </div>
    </div>
  );
};

export default AppMonitering;
